import React from 'react';

import AddMemberToFavourite from '@components/assign-team-member/AddMemberToFavourite';
import { BackButton } from '@components/buttons/BackButton';

import { isMyFavourite } from '@features/favourites/utils/favouriteUtil';
import { MIX_PANEL_EVENTS } from '@features/project-management-tools/constents';

import { useMixPanelTrakingEventMutation } from '@/api/commonApis';

const FavouriteDetailsTopHeader = ({ onEditFolder, folderInfo, children, folderId }) => {
	const [mixPanelTrakingEvent] = useMixPanelTrakingEventMutation();
	return (
		<div className="top-header collection-topbar">
			{/* Filter Contanier top */}
			<div className="container-fluid pt-3 pl-0">
				<div className="row">
					<div className="col-md-8">
						<div className="collection-overview d-flex align-items-center">
							<BackButton />
							<h1 className="semibold-14 m-0 ml-2">{folderInfo?.name} </h1>
							{folderInfo?.projectName && <span className="gray_dark_01 mr-1 ml-1">/</span>}
							{folderInfo?.projectName && (
								<span
									className="blue cursor-pointer text-underline"
									onClick={() => {
										mixPanelTrakingEvent({
											type: MIX_PANEL_EVENTS.ENTITY_LINK_ON_CLICK,
											body: {
												folderId: folderId,
												entityType: 'FAVOURITE',
												folderName: folderInfo?.name,
												projectName: folderInfo?.projectName
											}
										});
										window.open(`/my-project/${folderInfo?.projectId}`, '_blank');
									}}
								>
									{` ${folderInfo?.projectName}`}
								</span>
							)}
							{folderInfo?.brandResponse?.name && (
								<div className="collection-status pl-3 mr-2">
									<span className="brand-common-design">
										{folderInfo?.brandResponse?.name}
									</span>
								</div>
							)}

							{!isMyFavourite(folderId) && (
								<div className="ml-3">
									<span
										className={`regular-14 primary_bright_01 cursor-pointer ${folderInfo?.name === 'Sold Interest' ? 'cursor-none' : ''}`}
										onClick={() =>
											onEditFolder({
												name: folderInfo?.name,
												id: folderInfo?.id,
												brandResponse: folderInfo?.brandResponse,
												description: folderInfo?.description
											})
										}
									>
										Edit
									</span>
								</div>
							)}
						</div>
					</div>
					<div className="col-md-4">
						{!isMyFavourite(folderId) && (
							<AddMemberToFavourite
								folderId={folderInfo?.id || null}
								memberList={folderInfo?.members}
							/>
						)}
					</div>
				</div>
			</div>
			{children}
		</div>
	);
};

export default FavouriteDetailsTopHeader;
